import { render } from "./CategoriaVista.vue?vue&type=template&id=8bea8480&scoped=true"
import script from "./CategoriaVista.vue?vue&type=script&lang=js"
export * from "./CategoriaVista.vue?vue&type=script&lang=js"

import "./CategoriaVista.vue?vue&type=style&index=0&id=8bea8480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bea8480"]])

export default __exports__